import { useEffect, useState } from 'react';

export default function useCatalogScript() {
  const [isScriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');

    const setLoaded = () => {
      setScriptLoaded(true);
    };

    const timeout = setTimeout(() => {
      let existElementId = 'widget_oem_catalog';
      let levamWidgetCode = 'tvpvao';
      script.src = 'https://widgets.levam.net/oem-widget/loader.js';
      script.setAttribute('id', 'levam_oem_catalog');
      script.setAttribute('code', levamWidgetCode);
      script.setAttribute('start_brand', 'mercedes');
      let existElement = document.getElementById(existElementId);
      existElement?.parentNode?.insertBefore(script, existElement.nextSibling);
    }, 0);

    script.addEventListener('load', setLoaded);

    return () => {
      script.removeEventListener('load', setLoaded);
      clearTimeout(timeout);
    };
  }, []);

  return [isScriptLoaded];
}
